function cov_15ri7dtbhs() {
  var path = "/codebuild/output/src315236701/src/src/common/components/PlaySvg.vue";
  var hash = "e2bd60234beb9d7a07d4543941bd11476a6d3cf3";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src315236701/src/src/common/components/PlaySvg.vue",
    statementMap: {
      "0": {
        start: {
          line: 3,
          column: 19
        },
        end: {
          line: 3,
          column: 30
        }
      },
      "1": {
        start: {
          line: 4,
          column: 19
        },
        end: {
          line: 10,
          column: 1
        }
      },
      "2": {
        start: {
          line: 11,
          column: 33
        },
        end: {
          line: 11,
          column: 1062
        }
      },
      "3": {
        start: {
          line: 12,
          column: 19
        },
        end: {
          line: 20,
          column: 1
        }
      },
      "4": {
        start: {
          line: 21,
          column: 33
        },
        end: {
          line: 21,
          column: 99
        }
      },
      "5": {
        start: {
          line: 22,
          column: 33
        },
        end: {
          line: 25,
          column: 12
        }
      },
      "6": {
        start: {
          line: 26,
          column: 33
        },
        end: {
          line: 29,
          column: 12
        }
      },
      "7": {
        start: {
          line: 30,
          column: 19
        },
        end: {
          line: 34,
          column: 1
        }
      },
      "8": {
        start: {
          line: 35,
          column: 33
        },
        end: {
          line: 41,
          column: 6
        }
      },
      "9": {
        start: {
          line: 53,
          column: 8
        },
        end: {
          line: 70,
          column: 10
        }
      },
      "10": {
        start: {
          line: 54,
          column: 12
        },
        end: {
          line: 69,
          column: 32
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 51,
            column: 4
          },
          end: {
            line: 51,
            column: 5
          }
        },
        loc: {
          start: {
            line: 51,
            column: 19
          },
          end: {
            line: 71,
            column: 5
          }
        },
        line: 51
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 53,
            column: 15
          },
          end: {
            line: 53,
            column: 16
          }
        },
        loc: {
          start: {
            line: 53,
            column: 33
          },
          end: {
            line: 70,
            column: 9
          }
        },
        line: 53
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 56,
            column: 25
          },
          end: {
            line: 56,
            column: 74
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 56,
            column: 42
          },
          end: {
            line: 56,
            column: 57
          }
        }, {
          start: {
            line: 56,
            column: 60
          },
          end: {
            line: 56,
            column: 74
          }
        }],
        line: 56
      },
      "1": {
        loc: {
          start: {
            line: 59,
            column: 16
          },
          end: {
            line: 61,
            column: 51
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 60,
            column: 23
          },
          end: {
            line: 60,
            column: 76
          }
        }, {
          start: {
            line: 61,
            column: 22
          },
          end: {
            line: 61,
            column: 51
          }
        }],
        line: 59
      },
      "2": {
        loc: {
          start: {
            line: 64,
            column: 20
          },
          end: {
            line: 66,
            column: 55
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 65,
            column: 27
          },
          end: {
            line: 65,
            column: 102
          }
        }, {
          start: {
            line: 66,
            column: 26
          },
          end: {
            line: 66,
            column: 55
          }
        }],
        line: 64
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0
    },
    f: {
      "0": 0,
      "1": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0]
    },
    inputSourceMap: {
      version: 3,
      file: "/codebuild/output/src315236701/src/src/common/components/PlaySvg.vue.ts",
      sourceRoot: "",
      sources: ["/codebuild/output/src315236701/src/node_modules/vue-cli-plugin-quasar/lib/loader.js.transform-quasar-imports.js!/codebuild/output/src315236701/src/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!/codebuild/output/src315236701/src/node_modules/vue-cli-plugin-quasar/lib/loader.vue.auto-import-quasar.js??ruleSet[0].use[1]!/codebuild/output/src315236701/src/src/common/components/PlaySvg.vue?vue&type=script&setup=true&lang=ts"],
      names: [],
      mappings: "AAAA,OAAO,EAAE,eAAe,IAAI,gBAAgB,EAAE,MAAM,KAAK,CAAA;AACzD,OAAO,EAAE,SAAS,IAAI,UAAU,EAAE,kBAAkB,IAAI,mBAAmB,EAAE,kBAAkB,IAAI,mBAAmB,EAAE,kBAAkB,IAAI,mBAAmB,EAAE,cAAc,IAAI,eAAe,EAAE,iBAAiB,IAAI,kBAAkB,EAAE,MAAM,KAAK,CAAA;AAE1P,MAAM,UAAU,GAAG,CAAC,SAAS,CAAC,CAAA;AAC9B,MAAM,UAAU,GAAG;IACjB,GAAG,EAAE,CAAC;IACN,WAAW,EAAE,SAAS;IACtB,WAAW,EAAE,SAAS;IACtB,CAAC,EAAE,iyBAAiyB;IACpyB,IAAI,EAAE,cAAc;CACrB,CAAA;AACD,MAAM,UAAU,GAAG,aAAa,CAAA,kBAAkB,CAAC,8+BAA8+B,EAAE,CAAC,CAAC,CAAA;AACriC,MAAM,UAAU,GAAG;IACjB,GAAG,EAAE,CAAC;IACN,EAAE,EAAE,QAAQ;IACZ,EAAE,EAAE,MAAM;IACV,EAAE,EAAE,SAAS;IACb,EAAE,EAAE,KAAK;IACT,EAAE,EAAE,SAAS;IACb,aAAa,EAAE,gBAAgB;CAChC,CAAA;AACD,MAAM,UAAU,GAAG,aAAa,CAAA,mBAAmB,CAAC,MAAM,EAAE,EAAE,YAAY,EAAE,SAAS,EAAE,EAAE,IAAI,EAAE,CAAC,CAAC,CAAC,CAAA;AAClG,MAAM,UAAU,GAAG,aAAa,CAAA,mBAAmB,CAAC,MAAM,EAAE;IAC1D,MAAM,EAAE,KAAK;IACb,YAAY,EAAE,SAAS;CACxB,EAAE,IAAI,EAAE,CAAC,CAAC,CAAC,CAAA;AACZ,MAAM,UAAU,GAAG,aAAa,CAAA,mBAAmB,CAAC,MAAM,EAAE;IAC1D,MAAM,EAAE,GAAG;IACX,YAAY,EAAE,SAAS;CACxB,EAAE,IAAI,EAAE,CAAC,CAAC,CAAC,CAAA;AACZ,MAAM,UAAU,GAAG;IACjB,UAAU;IACV,UAAU;IACV,UAAU;CACX,CAAA;AACD,MAAM,UAAU,GAAG,aAAa,CAAA,mBAAmB,CAAC,UAAU,EAAE,EAAE,EAAE,EAAE,MAAM,EAAE,EAAE;IAC9E,aAAa,CAAA,mBAAmB,CAAC,MAAM,EAAE;QACvC,IAAI,EAAE,MAAM;QACZ,SAAS,EAAE,6BAA6B;QACxC,CAAC,EAAE,yBAAyB;KAC7B,CAAC;CACH,EAAE,CAAC,CAAC,CAAC,CAAA;AAGN,eAAe,aAAa,CAAA,gBAAgB,CAAC;IAC3C,MAAM,EAAE,SAAS;IACjB,KAAK,EAAE;QACP,MAAM,EAAE;YACN,IAAI,EAAE,OAAO;YACb,QAAQ,EAAE,KAAK;YACf,OAAO,EAAE,KAAK;SACf;KACF;IACC,KAAK,CAAC,OAAO;QAEf,4BAA4B;QAG5B,OAAO,CAAC,IAAS,EAAC,MAAW,EAAE,EAAE;YAC/B,OAAO,CAAC,UAAU,EAAE,EAAE,mBAAmB,CAAC,KAAK,EAAE;gBAC/C,KAAK,EAAE,4BAA4B;gBACnC,OAAO,EAAE,OAAO,CAAC,MAAM,CAAC,CAAC,CAAC,eAAe,CAAC,CAAC,CAAC,cAAc;gBAC1D,KAAK,EAAE,eAAe,CAAC,EAAE,UAAU,EAAE,OAAO,CAAC,MAAM,EAAC,UAAU,EAAG,CAAC,OAAO,CAAC,MAAM,EAAE,CAAC;aACpF,EAAE;gBACD,CAAC,CAAC,OAAO,CAAC,MAAM,CAAC;oBACf,CAAC,CAAC,CAAC,UAAU,EAAE,EAAE,mBAAmB,CAAC,MAAM,EAAE,UAAU,CAAC,CAAC;oBACzD,CAAC,CAAC,mBAAmB,CAAC,EAAE,EAAE,IAAI,CAAC;gBACjC,UAAU;gBACV,mBAAmB,CAAC,MAAM,EAAE,IAAI,EAAE;oBAChC,CAAC,CAAC,OAAO,CAAC,MAAM,CAAC;wBACf,CAAC,CAAC,CAAC,UAAU,EAAE,EAAE,mBAAmB,CAAC,gBAAgB,EAAE,UAAU,EAAE,UAAU,CAAC,CAAC;wBAC/E,CAAC,CAAC,mBAAmB,CAAC,EAAE,EAAE,IAAI,CAAC;oBACjC,UAAU;iBACX,CAAC;aACH,EAAE,EAAE,EAAE,UAAU,CAAC,CAAC,CAAA;QACrB,CAAC,CAAA;IACD,CAAC;CAEA,CAAC,CAAA",
      sourcesContent: ["import { defineComponent as _defineComponent } from 'vue'\nimport { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from \"vue\"\n\nconst _hoisted_1 = [\"viewBox\"]\nconst _hoisted_2 = {\n  key: 0,\n  \"fill-rule\": \"evenodd\",\n  \"clip-rule\": \"evenodd\",\n  d: \"M320.837 255.34h-52.848L291.818 119h-32.086l-28.43 161h85.171l4.364-24.66Zm-195.139-44.035a58.523 58.523 0 0 0 22.555-18.24 58.818 58.818 0 0 0 10.438-24.162 41.083 41.083 0 0 0 .96-9.712 36.436 36.436 0 0 0-3.073-16.005 36.849 36.849 0 0 0-9.765-13.131c-10.842-8.036-24.273-11.909-37.792-10.897H49.034L20 280h32.993l10.918-61.707h27.354a78.85 78.85 0 0 0 34.433-6.988Zm-.36-42.402c-1.087 6.804-4.571 13.012-9.838 17.529a31.835 31.835 0 0 1-21.475 6.396H68.11l8.638-48.087h25.675c15.236 0 22.915 6.277 22.915 18.121a26.53 26.53 0 0 1 0 6.041Zm392.509 80.436h-64.573L437.22 280h-34.011l86.811-161h37.816l29.373 161h-34.248l-5.114-30.661Zm-4.162-25.097-11.892-68.188-35.676 68.188h47.568Zm202.758-.319L790 119h-36.055l-48.234 73.149L683.885 119h-37.141l36.899 104.923L673.273 280h33.161l10.009-56.077Z\",\n  fill: \"url(#play-c)\"\n}\nconst _hoisted_3 = /*#__PURE__*/_createStaticVNode(\"<g clip-path=\\\"url(#play)\\\"><path d=\\\"M925.485 170.291h-.541l-20.03-20.03v-.541h.542l20.029 20.03v.541Z\\\" fill=\\\"#F86400\\\"></path><path d=\\\"m909.786 176.788-.544-.004-20.294-20.293-.003-.545.545.003 20.293 20.294.003.545Z\\\" fill=\\\"#FF2E7E\\\"></path><path d=\\\"M964.462 209.268v.541l20.03 20.03h.541v-.541l-20.029-20.03h-.542Z\\\" fill=\\\"#F86400\\\"></path><path d=\\\"m957.966 224.967.004.545 20.293 20.293.545.004-.004-.545-20.293-20.293-.545-.004Z\\\" fill=\\\"#FF2E7E\\\"></path><path d=\\\"m836.975 175.975 51.97-20.029 20.841 20.841-11.909 4.872 35.999 19.218 19.218 36 4.872-11.91 20.842 20.842-20.03 51.969-44.931-76.871-76.872-44.932Z\\\" fill=\\\"#FF2E7E\\\"></path><path d=\\\"m904.914 149.72 131.546-51.428-51.427 131.547-20.571-20.571 28.962-67.939c-21.023 8.549-67.939 28.962-67.939 28.962l-20.571-20.571Z\\\" fill=\\\"#F86400\\\"></path><path d=\\\"m904.914 149.72-15.969 6.225 20.841 20.842 15.699-6.496-20.571-20.571ZM985.041 229.847l-6.233 15.962-20.849-20.849 6.503-15.692 20.579 20.579Z\\\" fill=\\\"#FC4941\\\"></path></g>\", 1)\nconst _hoisted_4 = {\n  key: 0,\n  id: \"play-c\",\n  x1: \".887\",\n  y1: \"199.381\",\n  x2: \"790\",\n  y2: \"199.381\",\n  gradientUnits: \"userSpaceOnUse\"\n}\nconst _hoisted_5 = /*#__PURE__*/_createElementVNode(\"stop\", { \"stop-color\": \"#FF2E7E\" }, null, -1)\nconst _hoisted_6 = /*#__PURE__*/_createElementVNode(\"stop\", {\n  offset: \".49\",\n  \"stop-color\": \"#FC4941\"\n}, null, -1)\nconst _hoisted_7 = /*#__PURE__*/_createElementVNode(\"stop\", {\n  offset: \"1\",\n  \"stop-color\": \"#F86400\"\n}, null, -1)\nconst _hoisted_8 = [\n  _hoisted_5,\n  _hoisted_6,\n  _hoisted_7\n]\nconst _hoisted_9 = /*#__PURE__*/_createElementVNode(\"clipPath\", { id: \"play\" }, [\n  /*#__PURE__*/_createElementVNode(\"path\", {\n    fill: \"#fff\",\n    transform: \"rotate(45 448.578 1181.976)\",\n    d: \"M0 0h195.988v195.988H0z\"\n  })\n], -1)\n\n\nexport default /*#__PURE__*/_defineComponent({\n  __name: 'PlaySvg',\n  props: {\n  simple: {\n    type: Boolean,\n    required: false,\n    default: false,\n  },\n},\n  setup(__props) {\n\n/* eslint-disable max-len */\n\n\nreturn (_ctx: any,_cache: any) => {\n  return (_openBlock(), _createElementBlock(\"svg\", {\n    xmlns: \"http://www.w3.org/2000/svg\",\n    viewBox: __props.simple ? '745 0 400 400' : '0 0 1100 400',\n    class: _normalizeClass({ 'w-[30px]': __props.simple,'w-[60px]' : !__props.simple })\n  }, [\n    (!__props.simple)\n      ? (_openBlock(), _createElementBlock(\"path\", _hoisted_2))\n      : _createCommentVNode(\"\", true),\n    _hoisted_3,\n    _createElementVNode(\"defs\", null, [\n      (!__props.simple)\n        ? (_openBlock(), _createElementBlock(\"linearGradient\", _hoisted_4, _hoisted_8))\n        : _createCommentVNode(\"\", true),\n      _hoisted_9\n    ])\n  ], 10, _hoisted_1))\n}\n}\n\n})"]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "e2bd60234beb9d7a07d4543941bd11476a6d3cf3"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_15ri7dtbhs = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_15ri7dtbhs();
import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue";
const _hoisted_1 = (cov_15ri7dtbhs().s[0]++, ["viewBox"]);
const _hoisted_2 = (cov_15ri7dtbhs().s[1]++, {
  key: 0,
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M320.837 255.34h-52.848L291.818 119h-32.086l-28.43 161h85.171l4.364-24.66Zm-195.139-44.035a58.523 58.523 0 0 0 22.555-18.24 58.818 58.818 0 0 0 10.438-24.162 41.083 41.083 0 0 0 .96-9.712 36.436 36.436 0 0 0-3.073-16.005 36.849 36.849 0 0 0-9.765-13.131c-10.842-8.036-24.273-11.909-37.792-10.897H49.034L20 280h32.993l10.918-61.707h27.354a78.85 78.85 0 0 0 34.433-6.988Zm-.36-42.402c-1.087 6.804-4.571 13.012-9.838 17.529a31.835 31.835 0 0 1-21.475 6.396H68.11l8.638-48.087h25.675c15.236 0 22.915 6.277 22.915 18.121a26.53 26.53 0 0 1 0 6.041Zm392.509 80.436h-64.573L437.22 280h-34.011l86.811-161h37.816l29.373 161h-34.248l-5.114-30.661Zm-4.162-25.097-11.892-68.188-35.676 68.188h47.568Zm202.758-.319L790 119h-36.055l-48.234 73.149L683.885 119h-37.141l36.899 104.923L673.273 280h33.161l10.009-56.077Z",
  fill: "url(#play-c)"
});
const _hoisted_3 = ( /*#__PURE__*/cov_15ri7dtbhs().s[2]++, _createStaticVNode("<g clip-path=\"url(#play)\"><path d=\"M925.485 170.291h-.541l-20.03-20.03v-.541h.542l20.029 20.03v.541Z\" fill=\"#F86400\"></path><path d=\"m909.786 176.788-.544-.004-20.294-20.293-.003-.545.545.003 20.293 20.294.003.545Z\" fill=\"#FF2E7E\"></path><path d=\"M964.462 209.268v.541l20.03 20.03h.541v-.541l-20.029-20.03h-.542Z\" fill=\"#F86400\"></path><path d=\"m957.966 224.967.004.545 20.293 20.293.545.004-.004-.545-20.293-20.293-.545-.004Z\" fill=\"#FF2E7E\"></path><path d=\"m836.975 175.975 51.97-20.029 20.841 20.841-11.909 4.872 35.999 19.218 19.218 36 4.872-11.91 20.842 20.842-20.03 51.969-44.931-76.871-76.872-44.932Z\" fill=\"#FF2E7E\"></path><path d=\"m904.914 149.72 131.546-51.428-51.427 131.547-20.571-20.571 28.962-67.939c-21.023 8.549-67.939 28.962-67.939 28.962l-20.571-20.571Z\" fill=\"#F86400\"></path><path d=\"m904.914 149.72-15.969 6.225 20.841 20.842 15.699-6.496-20.571-20.571ZM985.041 229.847l-6.233 15.962-20.849-20.849 6.503-15.692 20.579 20.579Z\" fill=\"#FC4941\"></path></g>", 1));
const _hoisted_4 = (cov_15ri7dtbhs().s[3]++, {
  key: 0,
  id: "play-c",
  x1: ".887",
  y1: "199.381",
  x2: "790",
  y2: "199.381",
  gradientUnits: "userSpaceOnUse"
});
const _hoisted_5 = ( /*#__PURE__*/cov_15ri7dtbhs().s[4]++, _createElementVNode("stop", {
  "stop-color": "#FF2E7E"
}, null, -1));
const _hoisted_6 = ( /*#__PURE__*/cov_15ri7dtbhs().s[5]++, _createElementVNode("stop", {
  offset: ".49",
  "stop-color": "#FC4941"
}, null, -1));
const _hoisted_7 = ( /*#__PURE__*/cov_15ri7dtbhs().s[6]++, _createElementVNode("stop", {
  offset: "1",
  "stop-color": "#F86400"
}, null, -1));
const _hoisted_8 = (cov_15ri7dtbhs().s[7]++, [_hoisted_5, _hoisted_6, _hoisted_7]);
const _hoisted_9 = ( /*#__PURE__*/cov_15ri7dtbhs().s[8]++, _createElementVNode("clipPath", {
  id: "play"
}, [/*#__PURE__*/_createElementVNode("path", {
  fill: "#fff",
  transform: "rotate(45 448.578 1181.976)",
  d: "M0 0h195.988v195.988H0z"
})], -1));
export default /*#__PURE__*/_defineComponent({
  __name: 'PlaySvg',
  props: {
    simple: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  setup(__props) {
    cov_15ri7dtbhs().f[0]++;
    cov_15ri7dtbhs().s[9]++;
    /* eslint-disable max-len */
    return (_ctx, _cache) => {
      cov_15ri7dtbhs().f[1]++;
      cov_15ri7dtbhs().s[10]++;
      return _openBlock(), _createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: __props.simple ? (cov_15ri7dtbhs().b[0][0]++, '745 0 400 400') : (cov_15ri7dtbhs().b[0][1]++, '0 0 1100 400'),
        class: _normalizeClass({
          'w-[30px]': __props.simple,
          'w-[60px]': !__props.simple
        })
      }, [!__props.simple ? (cov_15ri7dtbhs().b[1][0]++, (_openBlock(), _createElementBlock("path", _hoisted_2))) : (cov_15ri7dtbhs().b[1][1]++, _createCommentVNode("", true)), _hoisted_3, _createElementVNode("defs", null, [!__props.simple ? (cov_15ri7dtbhs().b[2][0]++, (_openBlock(), _createElementBlock("linearGradient", _hoisted_4, _hoisted_8))) : (cov_15ri7dtbhs().b[2][1]++, _createCommentVNode("", true)), _hoisted_9])], 10, _hoisted_1);
    };
  }
});